import React, { useState, useEffect } from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { Link } from "react-router-dom";
import nointerviewsimage from "../../assests/nointerviewshere.png";
import { IoIosArrowDropright } from "react-icons/io";
export default function InterviewList({ interviews, from, filterTopic }) {
  const [currentFilter, setCurrentFilter] = useState(null);

  useEffect(() => {
    setCurrentFilter(filterTopic);
  }, [filterTopic]);

  const timeStampToDate = (timestamp) => {
    const date = new Date(timestamp);
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    const fullDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return `${fullDate}`;
  };

  const isReportAvailable = () => {
    return (
      <div className="flex ">
        <p className="px-1 text-yellow lg:text-xl">
          <FiAlertTriangle />
        </p>
        <p className="text-sm text-yellow lg:text-xl ">
          {" "}
          you haven't Completed the interview
        </p>
      </div>
    );
  };

  return (
    <div className="w-[100%] mx-auto items-center flex flex-col justify-center ">
      {interviews.length === 0 ? (
        <div className="past-interviews">
          <div className="rounded-[15px] w-[100%] mb-0 md:mb-[100%] lg:mb-[100%] grid grid-cols-2 items-center justify-center ">
            <img
              src={nointerviewsimage}
              className="md:w-[250px] md:h-[250px]  rounded-full"
              alt=""
            />
            <p className="text-base text-primary lg:text-xl">
              No Previous Interviews
            </p>
          </div>
        </div>
      ) : (
        <div className="w-[90%] md:space-x-3 md:p-3 lg:space-x-3 lg:p-3 rounded-lg no-scrollbar">
          <div className="sm:w-full md:mx-auto lg:mx-auto md:grid md:grid-cols-3 md:justify-center lg:grid lg:grid-cols-3 lg:justify-center p-2 past-interviews mx-auto">
            {interviews
              .slice()
              .reverse()
              .filter((interview) =>
                currentFilter
                  ? interview.technology.includes(currentFilter)
                  : true
              )
              .map((interview, index) => (
                <div className="p-4  lg:w-[56vh]" key={index}>
                  <div
                    className="pb-[10px] h-[200px] md:w-[400px] bg-white -ml-2 rounded-[10px] shadow-2xl shadow-slate-200 border mt-[17px] flex  justify-center lg:h-[300px]  lg:w-[500px]"
                    style={{ borderColor: "rgba(0, 0, 0, 0.07)" }}
                  >
                    <div className="flex flex-row pt-5 px-3 pr-6 lg:pt-8 ">
                      {interviews.length - index < 10 ? (
                        <h1 className="text-[20px] bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
                          0{interviews.length - index}
                        </h1>
                      ) : (
                        <h1 className="text-[20px] my-1 bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
                          {interviews.length - index}
                        </h1>
                      )}
                    </div>
                    <div className="flex flex-col items-start pt-4 lg:pt-6">
                      <div className="flex flex-col text-start lg:text-xl mb-3 lg:mb-6 ">
                        <p className="  my-auto  text-text_color3">
                          Topic: {interview?.technology}
                        </p>
                        <div className="flex flex-row ">
                          <p className="  my-auto text-primary ">
                            <span className=" text-text_color3 ">Level:</span>{" "}
                            {interview?.levelOfInterview}
                          </p>
                          <p className=" mx-auto my-auto text-xs text-text_color3 opacity-70 px-3 lg:text-lg ">
                            {timeStampToDate(interview?.createdAt)}
                          </p>
                        </div>
                        <h1 className=" my-auto text-text_color3 rounded-md py-1 w-60">
                          Questions: {interview?.noOfQuestions}
                        </h1>
                      </div>

                      {interview?.result.length > 0 ? (
                        <div className="flex text-xs  text-black lg:text-lg  ">
                          <div className=" pr-2">
                            <p className=" gil-med text-lg lg:text-2xl ">
                              {typeof interview?.result[2]?.score === 'number' && !isNaN(interview?.result[2]?.score) ? interview?.result[2].score.toFixed(1) : 0}%
                            </p>
                            <p className=" opacity-70">Communication</p>
                          </div>
                          <div className=" px-2">
                            <p className="text-lg gil-med lg:text-2xl">
                              {typeof interview?.result[1]?.score === 'number' && !isNaN(interview?.result[1]?.score) ? interview?.result[1].score.toFixed(1) : 0}%
                            </p>
                            <p className=" opacity-70">Technical Skills</p>
                          </div>
                          <div className=" px-2">
                            <p className="text-lg gil-med lg:text-2xl">
                              {typeof interview?.result[0]?.score === 'number' && !isNaN(interview?.result[0]?.score) ? interview?.result[0].score.toFixed(1) : 0}%
                            </p>
                            <p className=" opacity-70">Over all score</p>
                          </div>
                        </div>
                      ) : (
                        <div className="">{isReportAvailable()}</div>
                      )}

                      <Link
                        to={
                          from === "mobile"
                            ? `/report/${interview?._id}`
                            : `/dashboard/report/${interview?._id}`
                        }
                        className=" text-right my-auto flex items-center text-sm justify-start w-full "
                      >
                        {" "}
                        <span className="text-primary lg:text-xl">
                          View more
                        </span>{" "}
                        <IoIosArrowDropright className="text-primary mx-1 lg:text-xl lg:mt-1" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
